export default __webpack_public_path__ + "static/media/vert-image.1177dd60.jpeg";